import React, { FC, ReactElement } from "react"

import { useTranslation } from "react-i18next"

import { WelcomeSection } from "components/general/WelcomeSection"
import { TopBar } from "components/navigation/TopBar"
import { AccordionTable } from "components/tables/AccordionTable/AccordionTable"

import { GlobalAffiliateBulkEditor } from "features/referrals/GlobalAffiliateBulkEditor"

import { tableReferrals, tableReferralsCodes, tableReferrers } from "../constants/data"
import { useProps } from "../contexts/PropsContext"
import { referralsService } from "../services/referrals/referrals.service"

export const Referrals: FC = (): ReactElement => {
  const { user } = useProps()
  const { t } = useTranslation(["translation"], { useSuspense: false })

  return (
    <div className="grid w-full gap-8 p-8 pt-0 grid-col-1">
      <TopBar title={t("pages.referrals.title")} />
      {user && <WelcomeSection />}

      <GlobalAffiliateBulkEditor />

      <AccordionTable
        title={t("referrals.referrers")}
        handler={referralsService.getReferrersTable}
        columns={tableReferrers}
        renderExpanded={(referrerRow) => (
          <div className="p-4">
            <AccordionTable
              id={referrerRow.id}
              idTrue
              title={t("referrals.codes")}
              handler={referralsService.getReferralsCodesTable}
              columns={tableReferralsCodes}
              renderExpanded={(codeRow) => (
                <div className="p-4">
                  <AccordionTable
                    id={codeRow.code}
                    idTrue
                    title={t("referrals.referredUsers")}
                    handler={referralsService.getReferralsTable}
                    columns={tableReferrals}
                  />
                </div>
              )}
            />
          </div>
        )}
      />
    </div>
  )
}
